/* eslint-disable prettier/prettier */
import React from 'react';

import Wizard from 'components/Wizard';
import useCountry from 'hooks/useCountry';
import useStoreTranslation from 'hooks/useStoreTranslation';

import ApprovalOnboarding from './components/ApprovalOnboarding';
import ApprovalOrderOnboarding from './components/ApprovalOrderOnboarding';
import ApproversOnboarding from './components/ApproversOnboarding';
import EndOnboarding from './components/EndOnboarding';
import GroupOnboarding from './components/GroupOnboarding';
import ReviewOnboarding from './components/ReviewOnboarding';
import UsersOnboarding from './components/UsersOnboarding';

interface Props {
  adminEmail?: string;
  adminName?: string;
  adminLastName?: string;
}

const AdminOnboarding = ({ adminEmail, adminName, adminLastName }: Props) => {
  const country = useCountry();
  const { t } = useStoreTranslation();

  return (
    <>
      <Wizard
        start={0}
        initialData={{
          company: {
            countryId: country.id,
          },
          users: [],
          approvers: [],
          adminUser: {},
          ruleName: t('adminSignUp.ruleName'),
        }}
      >
        <GroupOnboarding />
        <UsersOnboarding />
        <ApprovalOnboarding />
        <ApproversOnboarding adminEmail={adminEmail} adminName={adminName} adminLastName={adminLastName} />
        <ApprovalOrderOnboarding />
        <ReviewOnboarding />
        <EndOnboarding />
      </Wizard>
    </>
  );
};

export default AdminOnboarding;
